import { ParsedUrlQuery } from 'querystring'
import { SortDirectionEnum } from 'shared/components/table/enums'
import { useSorter } from '../hooks/use-sorter'

export const setSortFromQuery = <T extends string>(
  query: ParsedUrlQuery,
  defaultSort?: useSorter.SortInterface<T>,
) => {
  const sort = {} as useSorter.SortInterface<T>
  if (query['sortColumn']) {
    sort.sortColumn = query['sortColumn'] as T
  }
  if (query['sortDirection']) {
    sort.sortDirection = query['sortDirection'] as SortDirectionEnum
  }

  return {
    ...defaultSort,
    ...sort,
  }
}
